const tlds = require('./tlds.json');


export function email(e) {
    var code;
    var msg;
    var err;
    if(e.includes('@')) {
        tlds.some(el => {
            if(e.includes(el['Domain'])) {
                code = 200;
                msg = '';
                err = false;
                return [code, msg, err];
            } else {
                code = 42;
                msg = 'It looks like you\'re missing a top level domain (e.g. \'.com\', \'.net\', \'.org\').';
                err = true;
            }
        });
    } else {
      code = 43;
      msg = 'It looks like you\'re missing an \'@\'.';
      err = true;
    }
    return [code, msg, err];
}
export function how(e) {
    var err;
    var msg = '';
    if(e.split('').length < 255) {
      err = false;
    } else {
      err = true;
      msg = 'Please limit this field to 255 characters.'
    }
    return [err, msg];

}
export function changed(e) {

}